import { Plugin } from 'ckeditor5/src/core';
import VideoPropertiesEditing from './video-properties-editing';
import VideoPropertiesUI from './video-properties-ui';

export default class VideoProperties extends Plugin {
	static get requires() {
		return [VideoPropertiesEditing, VideoPropertiesUI];
	}

	static get pluginName() {
		return 'VideoProperties';
	}
}
